import {LOCAL_STORAGE_ACCESS_TOKEN_KEY} from "../api/auth";
import {CardPosition, CardType, PlayerCardHolder} from "./types/game";

export function noAction() {
    // stub for no action
}

export function toInitials(username: string) {
    return username.slice(0, 1).toUpperCase();
}

export function isLoggedIn(): boolean {
    let accessToken = localStorage.getItem(LOCAL_STORAGE_ACCESS_TOKEN_KEY);
    return !!accessToken && accessToken !== 'null' && accessToken !== 'undefined';
}

export function parseJwtFromToken(token: string): object {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
        window.atob(base64)
            .split('')
            .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
            .join(''),
    );

    return JSON.parse(jsonPayload);
}

export function toWebSocketUrl(httpUrl: string): string {
    const url = new URL(httpUrl);
    const wsProtocol = url.protocol === 'https:' ? 'wss:' : 'ws:';
    return `${wsProtocol}//${url.host}/ws`;
}

export function toNum(str: string | undefined | null): number {
    return +(str ?? Number.NaN);
}

export function splitCardsToRows(playerCards?: PlayerCardHolder): CardPosition[][] {
    if (!playerCards) {
        return [];
    }

    const rows: CardPosition[][] = [];

    let maxCardIdx = 0;

    for (const [key, cardValue] of Object.entries(playerCards.cards)) {
        const cardSlot = Number(key);
        const rowIndex = Math.floor(cardSlot / 100);
        const cardIndex = rowIndex === 0 ? cardSlot : cardSlot % (100 * rowIndex);

        maxCardIdx = Math.max(maxCardIdx, cardIndex);

        if (!rows[rowIndex]) {
            rows[rowIndex] = [];
        }

        rows[rowIndex][cardIndex] = {slot: cardSlot, card: cardValue};
    }

    for (let i = 0; i < playerCards.rows; i++) {
        if (!rows[i]) {
            rows[i] = [];
        }

        for (let j = 0; j <= maxCardIdx; j++) {
            if (!rows[i][j]) {
                rows[i][j] = {slot: i * 100 + j, card: {id: -404, type: CardType.EMPTY}};
            }
        }
    }

    return rows;
}
